var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.recommend_type.length)?_c('div',[_vm._v("-")]):_vm._l((_vm.recommend_type),function(item,index){return _c('div',{key:index},[_vm._v(_vm._s(item))])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }